import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const MemberNameToolTip = () => (
    <CustomToolTip
        type="?"
        info="The Member name you enter is what will show as the publisher on works registration."
    />
)

export default MemberNameToolTip
